// extracted by css-extract-rspack-plugin
export default {"control":"CategoryControls_control__91imX","sizeM":"CategoryControls_sizeM__jpsJr"};